// Mixpanel-specific implementation behind the AnalyticsClient interface.
// Feature code never imports from this file — go through `./index.ts`.

import mixpanel from 'mixpanel-browser'
import { config } from '@core/config'
import { getSessionId } from '@core/logging'

let initialised = false

export const mixpanelClient = {
  init(): void {
    if (initialised) return
    if (!config.mixpanel.token) return
    mixpanel.init(config.mixpanel.token, {
      debug: config.isDev,
      track_pageview: false, // page tracking is router-driven, not auto
      persistence: 'localStorage',
      ignore_dnt: false,
      api_host: config.mixpanel.apiHost || undefined,
    })
    // session_id + service identity ride on every Mixpanel event as
    // super-properties so the same ids appear here, in Sentry, and in
    // our own logger output. Backend ingest can join on session_id.
    mixpanel.register({
      session_id: getSessionId(),
      service_name: config.app.name,
      service_version: config.app.version,
    })
    initialised = true
  },

  identify(userId: string, traits?: Record<string, unknown>): void {
    if (!initialised) return
    mixpanel.identify(userId)
    if (traits) mixpanel.people.set(traits)
  },

  track(event: string, props?: Record<string, unknown>): void {
    if (!initialised) return
    mixpanel.track(event, props)
  },

  page(name: string | undefined, props?: Record<string, unknown>): void {
    if (!initialised) return
    mixpanel.track('page_viewed', {
      page: name,
      url: typeof window !== 'undefined' ? window.location.pathname : undefined,
      ...props,
    })
  },

  reset(): void {
    if (!initialised) return
    mixpanel.reset()
  },
}
